// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.EmpDashCards1234
{
  margin-top: 30px;
}


.EmpLeaveTracker123 {
    padding: 0;
    
    
    flex-grow: 0;
    margin-top:3%;
    padding: 0%;
    display: flex;
    flex-direction: column;
    align-items: center;
   
    
  }

  .EmpLeaveTracker123 h2
  {
    margin-right: 74%;
    margin-bottom: -2%;
    
  }

  .empcardcharts123 {
    
    display: flex;
    gap: 34px; /* Space between charts */
    margin-top: 5%;
    align-items: center;
    flex-wrap: wrap; /* Allows wrapping on smaller screens */
    justify-content: center; /* Centers items properly */
    width: 100%; /* Ensures it takes full width */
    padding: 0 0%; /* Adds padding to avoid touching edges */
  }
 
  .mydailyworkhour123
  {
    display: flex;  
      justify-content: space-evenly; /* Adjust as needed */
      /* Adds space between the charts */
      /* Ensures responsiveness */
    
  }

  .EmpProjectTable
  {
    display: flex;
    margin-top: 3%;
  }

  /* Overlay background */
.reg-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* dark translucent backdrop */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Popup box */
.reg-popup-content {
 padding: 10px;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  text-align: center;
 
  animation: scaleIn 0.25s ease-in-out;
}

/* Optional animation */
@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 780px) {
  .reg-popup-content {
    width: 100%;
    padding: 12px 10px;
    border-radius: 10px;
    margin-left: 0%;
  }

  .reg-popup-overlay {
    
    padding-top: 0px; /* allows popup to show lower on small screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/MyEmpDashboard.css"],"names":[],"mappings":";AACA;;EAEE,gBAAgB;AAClB;;;AAGA;IACI,UAAU;;;IAGV,YAAY;IACZ,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;;EAGrB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;;EAEpB;;EAEA;;IAEE,aAAa;IACb,SAAS,EAAE,yBAAyB;IACpC,cAAc;IACd,mBAAmB;IACnB,eAAe,EAAE,uCAAuC;IACxD,uBAAuB,EAAE,2BAA2B;IACpD,WAAW,EAAE,gCAAgC;IAC7C,aAAa,EAAE,yCAAyC;EAC1D;;EAEA;;IAEE,aAAa;MACX,6BAA6B,EAAE,qBAAqB;MACpD,kCAAkC;MAClC,2BAA2B;;EAE/B;;EAEA;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA,uBAAuB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,8BAA8B;EAC9D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;CACC,aAAa;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;;EAElB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB,EAAE,gDAAgD;EACpE;AACF","sourcesContent":["\n.EmpDashCards1234\n{\n  margin-top: 30px;\n}\n\n\n.EmpLeaveTracker123 {\n    padding: 0;\n    \n    \n    flex-grow: 0;\n    margin-top:3%;\n    padding: 0%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n   \n    \n  }\n\n  .EmpLeaveTracker123 h2\n  {\n    margin-right: 74%;\n    margin-bottom: -2%;\n    \n  }\n\n  .empcardcharts123 {\n    \n    display: flex;\n    gap: 34px; /* Space between charts */\n    margin-top: 5%;\n    align-items: center;\n    flex-wrap: wrap; /* Allows wrapping on smaller screens */\n    justify-content: center; /* Centers items properly */\n    width: 100%; /* Ensures it takes full width */\n    padding: 0 0%; /* Adds padding to avoid touching edges */\n  }\n \n  .mydailyworkhour123\n  {\n    display: flex;  \n      justify-content: space-evenly; /* Adjust as needed */\n      /* Adds space between the charts */\n      /* Ensures responsiveness */\n    \n  }\n\n  .EmpProjectTable\n  {\n    display: flex;\n    margin-top: 3%;\n  }\n\n  /* Overlay background */\n.reg-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4); /* dark translucent backdrop */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Popup box */\n.reg-popup-content {\n padding: 10px;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 90%;\n  text-align: center;\n \n  animation: scaleIn 0.25s ease-in-out;\n}\n\n/* Optional animation */\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 780px) {\n  .reg-popup-content {\n    width: 100%;\n    padding: 12px 10px;\n    border-radius: 10px;\n    margin-left: 0%;\n  }\n\n  .reg-popup-overlay {\n    \n    padding-top: 0px; /* allows popup to show lower on small screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
